import MetaSettings from '@/modules/integrations/types/meta/MetaSettings'
import MetaOverview from '@/modules/integrations/types/meta/MetaOverview'
import MetaSyncDialog from '@/modules/integrations/types/meta/MetaSyncDialog'
import MetaReauthenticateDialog from '@/modules/integrations/types/meta/MetaReauthenticateDialog'

export default Object.freeze({
  type: 'meta',
  title: 'Integrations_Meta',
  category: 'Integrations_Advertising_Category',
  description: 'Integrations_Meta_Description',
  image: require('@/img/integrations/meta.png'),
  requiresAdmin: false,
  connectUrl: function(domain, projectId, integrationId = null) {
    if (integrationId) {
      return `${domain}/integration/meta/redirect?project_id=${projectId}&integration_id=${integrationId}`
    }
    return `${domain}/integration/meta/redirect?project_id=${projectId}`
  },
  components: {
    settings: MetaSettings,
    overview: MetaOverview
  },
  actions: [
    {
      icon: 'el-icon-refresh-right',
      label: 'Integrations_Meta_Action_Reauthenticate',
      dialog: MetaReauthenticateDialog
    },
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_Meta_Action_Sync',
      dialog: MetaSyncDialog
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/ad-retargeting'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/meta/index.js